import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Bubba } from "@/lib/Bubba";
import { api } from "@/lib/api";

const SEX = ["Male", "Female"];
const ACTIVITY = [["sedentary", "Sedentary"], ["light", "Light"], ["moderate", "Moderate"], ["active", "Active"], ["very_active", "Very Active"]];
const RATE = [[-2, "Lose 2 lb/wk"], [-1, "Lose 1 lb/wk"], [-0.5, "Lose 0.5 lb/wk"], [0, "Maintain"], [0.5, "Gain 0.5 lb/wk"]];

function Seg({ options, value, onChange }) {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((o) => {
        const val = Array.isArray(o) ? o[0] : o;
        const label = Array.isArray(o) ? o[1] : o;
        const active = value === val;
        return (
          <button key={String(val)} onClick={() => onChange(val)}
            className={`px-4 py-2.5 rounded-full text-sm font-semibold border transition-colors ${active ? "bg-[#651F33] border-[#651F33] text-[#F5F0E8]" : "bg-white border-[#E3D9C8] text-slate-500 hover:border-[#651F33]/50"}`}>
            {label}
          </button>
        );
      })}
    </div>
  );
}

const inputCls = "w-full bg-white border border-[#E3D9C8] rounded-2xl px-4 py-3 text-slate-900 text-base font-semibold outline-none focus:border-[#651F33]";

export default function Onboarding() {
  const navigate = useNavigate();
  const [f, setF] = useState({ age: "", height_cm: "", weight: "", target: "", sex: "Male", activity: "light", rate: -1 });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }));

  const submit = async () => {
    if (!f.age || !f.height_cm || !f.weight || !f.target) { toast.error("Please fill in all fields"); return; }
    setSaving(true);
    try {
      await api("/profile", { method: "POST", body: {
        age: parseInt(f.age), sex: f.sex.toLowerCase(), height_cm: parseFloat(f.height_cm),
        weight_lbs: parseFloat(f.weight), target_weight_lbs: parseFloat(f.target),
        target_rate_lbs_week: f.rate, activity_level: f.activity, ai_persona: "buddy",
      }});
      navigate("/app");
    } catch (e) { toast.error(e.message); } finally { setSaving(false); }
  };

  return (
    <div className="min-h-screen bg-[#F5F0E8] py-10 px-6">
      <div className="max-w-lg mx-auto">
        <div className="flex flex-col items-center"><Bubba mood="Happy" size={110} /></div>
        <h1 className="text-3xl font-extrabold text-slate-900 text-center mt-2">Let's set up your plan</h1>
        <p className="text-slate-500 text-center mt-2">Bubba uses this to calculate your daily calorie & macro goals.</p>

        <div className="grid grid-cols-2 gap-3 mt-6">
          <div><label className="text-sm text-slate-500 font-semibold">Age</label>
            <input data-testid="onboarding-age-input" className={`${inputCls} mt-2`} value={f.age} onChange={(e) => set("age", e.target.value)} inputMode="numeric" placeholder="30" /></div>
          <div><label className="text-sm text-slate-500 font-semibold">Height (cm)</label>
            <input data-testid="onboarding-height-input" className={`${inputCls} mt-2`} value={f.height_cm} onChange={(e) => set("height_cm", e.target.value)} inputMode="numeric" placeholder="175" /></div>
          <div><label className="text-sm text-slate-500 font-semibold">Weight (lb)</label>
            <input data-testid="onboarding-weight-input" className={`${inputCls} mt-2`} value={f.weight} onChange={(e) => set("weight", e.target.value)} inputMode="numeric" placeholder="180" /></div>
          <div><label className="text-sm text-slate-500 font-semibold">Goal weight (lb)</label>
            <input data-testid="onboarding-target-weight-input" className={`${inputCls} mt-2`} value={f.target} onChange={(e) => set("target", e.target.value)} inputMode="numeric" placeholder="160" /></div>
        </div>

        <p className="text-sm text-slate-500 font-semibold mt-5 mb-2">Sex</p>
        <Seg options={SEX} value={f.sex} onChange={(v) => set("sex", v)} />
        <p className="text-sm text-slate-500 font-semibold mt-5 mb-2">Activity level</p>
        <Seg options={ACTIVITY} value={f.activity} onChange={(v) => set("activity", v)} />
        <p className="text-sm text-slate-500 font-semibold mt-5 mb-2">Weekly goal</p>
        <Seg options={RATE} value={f.rate} onChange={(v) => set("rate", v)} />

        <button data-testid="onboarding-submit-button" onClick={submit} disabled={saving}
          className="w-full mt-8 bg-[#651F33] hover:bg-[#521829] transition-colors text-[#F5F0E8] font-bold py-4 rounded-full disabled:opacity-60">
          {saving ? "Saving..." : "Start my journey"}
        </button>
      </div>
    </div>
  );
}
